// extracted by css-extract-rspack-plugin
export default {"Panel":"ArtifactsSidePanelEmbedded-module__Panel__oWn3N","closed":"ArtifactsSidePanelEmbedded-module__closed__xX_Wg","Content":"ArtifactsSidePanelEmbedded-module__Content__razKW"};